import { DealerOptionDto } from '@api/machines'
import { BRAND_FAMILIES, groupBy } from '@common/utils'
import { useMemo } from 'react'

export const useDealerFits = (dealerOptions: DealerOptionDto[]) => {
  const sortedDealerOptions = useMemo(() => {
    const families = groupBy(dealerOptions, 'family')
    const groups = groupBy(dealerOptions, 'group')

    const groupedDealerOptions = {
      ...families,
      ...groups
    }

    const sortedKeys = [...Object.keys(families), ...Object.keys(groups)].sort(
      (a, b) => {
        const aLower = a.toLowerCase()
        const bLower = b.toLowerCase()

        // Ensures 'Bucket' comes first, then 'Hitch', then others alphabetically
        if (aLower === BRAND_FAMILIES.BUCKET.toLowerCase()) {
          return -1
        }
        if (bLower === BRAND_FAMILIES.BUCKET.toLowerCase()) {
          return 1
        }
        if (aLower === BRAND_FAMILIES.HITCH.toLowerCase()) {
          return -1
        }
        if (bLower === BRAND_FAMILIES.HITCH.toLowerCase()) {
          return 1
        }

        return aLower.localeCompare(bLower)
      }
    )

    const sortedData: {
      [k: string]: DealerOptionDto[]
    } = {}

    for (const key of sortedKeys) {
      sortedData[key] = groupedDealerOptions[key]
    }

    return sortedData
  }, [dealerOptions])

  const hasDealerFits =
    sortedDealerOptions && Object.entries(sortedDealerOptions).length > 0

  return {
    dealerFitsOptions: sortedDealerOptions,
    hasDealerFits
  }
}
